import 'bootstrap/dist/css/bootstrap.min.css'

import { Container, Row, Col } from 'react-bootstrap'
import backgroundImage from "../../img/flyermaker-header-filled.jpg"

const FlyerMakerHeader = () => {
    const headerStyle = {
        color: '#ffffff',
        //backgroundColor: '#433911'
        
        backgroundColor: '#000000'
        
    }
    /*const headerImageStyle = {
        backgroundImage: `url(${backgroundImage})`,
    }*/

    return (
        <Container fluid style={headerStyle} className='text-start'>
            <Container>
                <Row><Col xs={12} className="me-auto" style={{marginLeft: "-1vw"}}>
                    <img src={backgroundImage} alt="Marketing Campaigns Database Background"></img>
                </Col></Row>
            </Container>
            
            {/*<Container style={{paddingRight: "30px"}} >
                <Row><Col xs={12}><img src={backgroundImage}></img></Col></Row>
            </Container>
            <Row>
                <Col xs={6}>
                    <h2>MARKETING CAMPAIGNS DATABASE</h2>
                </Col>
                {/*<Col xs={6} className='text-end align-self-center'>
                    <Button style={{backgroundColor: '#ffffff', color: '#433911'}} onClick={() => fetch('/api/backup_db')}>Backup Database</Button>
                </Col>
            </Row>*/}
        </Container>
    );
}
 
export default FlyerMakerHeader;